import api from '../api';

export const getInventoryFilters = async () => {
  const res = await api.get('/utils/filters');
  return res.data;
};

export const getInventoryMaterials = async (projectId) => {
  const res = await api.get(`/api/aims/v2/inventory/materials`);
  return res.data;
};

export const getInventoryMaterialsPaginated = async (projectId, { page = 0, size = 20, search = '' } = {}) => {
  const params = {
    page,
    size,
    search,
  };
  const res = await api.get(`/api/aimsinventory/materials/${projectId}/paginated`, { params });
  return res.data;
};

export const getInventoryIssuancesPaginated = async (
  projectId,
  {
    page = 0,
    size = 10,
    search = '',
    region = '',
    area = '',
    startDate = '',
    endDate = '',
  } = {}
) => {
  const params = {
    page,
    size,
    search: search || undefined,
    region: region || undefined,
    area: area || undefined,
    startDate: startDate || undefined,
    endDate: endDate || undefined,
  };

  // projectId is kept for API compatibility if backend supports it as query filter.
  if (projectId) params.projectId = Number(projectId);

  const res = await api.get('/api/aims/v2/inventory/issuances', { params });
  return res.data;
};

export const deleteInventoryIssuance = async (issuanceId) => {
  const res = await api.delete(`/api/aims/v2/inventory/issuances/${issuanceId}`);
  return res.data;
};

export const deleteInventoryRedistribution = async (distributionId) => {
  const res = await api.delete(`/api/aims/v2/inventory/redistributions/${distributionId}`);
  return res.data;
};

export const getInventoryIssuanceMetrics = async (giNumber) => {
  const res = await api.get(
    `/api/aims/v2/inventory/issuances/${encodeURIComponent(giNumber)}/metrics`
  );
  return res.data;
};

export const getInventoryIssuanceSummary = async (giNumber) => {
  const res = await api.get(
    `/api/aims/v2/inventory/issuances/${encodeURIComponent(giNumber)}/summary`
  );
  return res.data;
};

export const syncDeployed = async (projectId, startDate, endDate) => {
  const res = await api.patch('/api/aims/v2/deployed', {
    startDate,
    endDate,
    projectId: Number(projectId),
  }, {
    timeout: 0, // No timeout for sync operation
  });
  return res.data;
};
